import React from 'react';
import {
  Spin,
  Select,
} from 'antd';
import debounce from 'lodash/debounce';

export default class SearchInput extends React.PureComponent {
  constructor(props) {
    super(props);
    const { defaultData } = this.props;
    this.state = {
      data: defaultData,
      loading: false,
    };
  }

  render() {
    const { loading, data } = this.state;
    const {
      value, onChange, notFoundContent, disabled,
    } = this.props;
    const options = data.map(d => <Select.Option key={d.value}>{d.text}</Select.Option>);
    return (
      <Select
        labelInValue
        showSearch
        defaultActiveFirstOption={false}
        showArrow={false}
        value={value}
        disabled={disabled}
        filterOption={false}
        onSearch={debounce(this.handleSearch, 500, { leading: false, trailing: true })}
        onChange={onChange}
        notFoundContent={loading ? <Spin size="small" /> : notFoundContent}
        onBlur={this.reset}
      >
        {options}
      </Select>
    );
  }

  reset = () => {
    const { defaultData } = this.props;
    this.setState({
      data: defaultData,
      loading: false,
    });
  }

  handleSearch = async (value) => {
    const { onSearch, allowTyping } = this.props;
    this.setState({
      loading: true,
      data: [],
    });
    try {
      const resp = await onSearch(value);
      const { data } = resp;
      if (allowTyping) {
        const values = data.map(d => d.value);
        if (value.length && !values.includes(value)) {
          data.unshift({
            value,
            text: value,
          });
        }
      }
      this.setState({
        data,
        loading: false,
      });
    } catch {
      this.setState({
        loading: false,
      });
    }
  }
}

SearchInput.defaultProps = {
  notFoundContent: 'Not Found',
  disabled: false,
  defaultData: [],
  allowTyping: false,
};
